export const GET_PARTS_AUTO = 'top-bar/get-parts';
export const GET_PARTS_AUTO_ERROR = 'top-bar/get-parts-error';
export const GET_PARTS_AUTO_SUCCESS = 'top-bar/get-parts-success';
export const GET_COMPANIES = 'top-bar/get-companies';
export const GET_COMPANIES_SUCCESS = 'top-bar/get-companies-success';
export const GET_COMPANIES_ERROR = 'top-bar/get-companies-error';
